import createReducer from '../../utils/createReducer';
import { AIRMEET_STATUS } from '../actions/airmeet';
import {
    ACCEPT_TABLE_INVITE,
    ADD_TABLE_INVITE,
    DELETE_TABLE_INVITE,
    SOCIAL_LOUNGE_AUTO_JOIN_TABLE,
    SOCIAL_LOUNGE_DATA,
    UPDATE_AIRMEET_JOINED_TABLE,
    UPDATE_AIRMEET_TABLE_STREAM_STATUS,
    UPDATE_SOCIAL_LOUNGE_TABLE_CHAIRS,
    UPDATE_TABLE_INVITE,
    SET_SPEED_NETWORKING_MOUNTED,
} from '../actions/SocialLounge';

const initialState = {
    joinedTable: {},
    initJoinedTable: {},
    totalLiveMembers: [],
    active: false,
    activeSpeaker: false,
    invites: {},
    acceptedInvite: null,
    isSpeedNetworkingMounted: false,
};

const handlers = {};

handlers[SOCIAL_LOUNGE_DATA] = (state = initialState, { payload }) => {
    return { ...state, initJoinedTable: {}, ...payload };
};

handlers[SOCIAL_LOUNGE_AUTO_JOIN_TABLE] = (state = initialState, action) => {
    const { lounge, code, tableName, chair, userId } = action.payload;
    const initJoinedTable = { lounge, code, tableName, chair, userId };
    return { ...state, initJoinedTable };
};

handlers[AIRMEET_STATUS] = (state = initialState, action) => {
    let active = Math.random();
    return { ...state, active };
};

handlers[UPDATE_AIRMEET_TABLE_STREAM_STATUS] = (
    state = initialState,
    action
) => {
    return {
        ...state,
        joinedTable: {
            ...state.joinedTable,
            status: action.payload,
        },
    };
};

handlers[UPDATE_AIRMEET_JOINED_TABLE] = (state = initialState, { payload }) => {
    const updatedTable =
        !!payload && !payload.reset
            ? {
                  ...state.joinedTable,
                  ...payload,
              }
            : {};

    return {
        ...state,
        joinedTable: updatedTable,
    };
};

handlers[UPDATE_SOCIAL_LOUNGE_TABLE_CHAIRS] = (
    state = initialState,
    { payload }
) => {
    const { code, chairs } = payload || {};
    console.log(code);
    console.log(chairs);
    if (code && chairs && state.tables && state.tables[code]) {
        state.tables[code].chairs = { ...state.tables[code].chairs, ...chairs };
        state.tables[code] = { ...state.tables[code] };
    }
    return { ...state };
};

handlers[ACCEPT_TABLE_INVITE] = (state = initialState, { payload }) => {
    const { userId } = payload;
    return state.acceptedInvite !== userId
        ? {
              ...state,
              acceptedInvite: userId,
          }
        : state;
};

handlers[ADD_TABLE_INVITE] = (state = initialState, { payload }) => {
    const { number, userId } = payload;
    return number && userId
        ? { ...state, invites: { ...state.invites, [userId]: { number } } }
        : state;
};

handlers[UPDATE_TABLE_INVITE] = (state = initialState, { payload }) => {
    return payload
        ? { ...state, invites: { ...state.invites, ...payload } }
        : state;
};

handlers[DELETE_TABLE_INVITE] = (state = initialState, { payload }) => {
    const { userId } = payload;

    const { invites: existingInvites } = state;
    if (userId && existingInvites[userId]) {
        delete existingInvites[userId];
        return { ...state, invites: { ...existingInvites } };
    }

    return state;
};

handlers[SET_SPEED_NETWORKING_MOUNTED] = (
    state = initialState,
    { payload }
) => {
    return { ...state, isSpeedNetworkingMounted: payload };
};

export default createReducer(initialState, handlers);
